import { Text, VStack, Box } from '@chakra-ui/react'
import { useTranslation } from 'next-i18next'

import OurServices from '@/features/aboutUs/components/OurServices'
import { useServiceData } from '@/features/aboutUs/constants/ourServices'
import { NAVIGATION_BAR_HEIGHT } from '@/components/NavigationBar/constants'

function AboutUs(): React.ReactElement {
  const { t } = useTranslation('aboutUs')

  const SUMMARIES = useServiceData()

  return (
    <Box
      as="section"
      sx={{
        w: 'full',
      }}
    >
      <VStack
        layerStyle="container"
        spacing={{
          base: 6,
          md: 9,
        }}
        sx={{
          w: 'full',
          minH: {
            base: `calc(100vh - ${NAVIGATION_BAR_HEIGHT.base})`,
            md: `calc(100vh - ${NAVIGATION_BAR_HEIGHT.md})`,
          },
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Text
          as="h1"
          sx={{
            mt: 'auto',
            fontSize: { base: 'xl', md: '2xl' },
            fontWeight: 'medium',
            textAlign: 'center',
            px: {
              base: 8,
              sm: 10,
            },
          }}
        >
          {t('aboutUs.title')}
        </Text>
        <VStack
          spacing="6"
          sx={{
            mb: 'auto !important',
            alignItems: 'stretch',
          }}
        >
          <Text
            as="h2"
            sx={{
              fontSize: { base: 'xl', md: '2xl' },
              fontWeight: 'medium',
              textAlign: {
                base: 'center',
                md: 'left',
              },
            }}
          >
            {t('aboutUs.services.title')}
          </Text>
          <OurServices summaries={SUMMARIES} />
        </VStack>
      </VStack>
    </Box>
  )
}

export default AboutUs
